import { render } from "./NewAsideDevice.vue?vue&type=template&id=c167cf2a&scoped=true"
import script from "./NewAsideDevice.vue?vue&type=script&lang=js"
export * from "./NewAsideDevice.vue?vue&type=script&lang=js"

import "./NewAsideDevice.vue?vue&type=style&index=0&id=c167cf2a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c167cf2a"]])

export default __exports__